import { useLanguage } from '@src/language';

export const useBlockPanelContent = (isBlockType: boolean) =>
  useLanguage({ prefix: `naming.mrc.rightSidebar.${isBlockType ? 'block' : 'clause'}` });
